import antdEn from 'antd/lib/locale-provider/en_US';
import enMessages from '../locales/en_US.json';
import d3enUS from 'd3-format/locale/en-US';

const EnLang = {
  messages: {
    ...enMessages,
  },
  antd: antdEn,
  locale: 'en-US',
  moment: 'en',
  numeral: 'en',
  d3: d3enUS,
  label: 'English',
  app: 'en'
};
export default EnLang;
